import React, { useEffect, useState } from "react";
import { Alert, Button } from "react-bootstrap";
import AnchorLink from "anchor-link";
import AnchorLinkBrowserTransport from "anchor-link-browser-transport";
import blockchains from "../../assets/blockchains.json";
import { toastError } from "../../helpers";
import { useTranslation } from "react-i18next";

const TransferNftButton = ({setIdentitySession, identitySession}) => {
  const {t} = useTranslation();
  const [link, setLink] = useState();
  const [sessions, setSessions] = useState();

  const transport = new AnchorLinkBrowserTransport();
  const establishLink = async () => {
    const eLink = new AnchorLink({
      transport,
      chains: blockchains.map((b) => ({
        chainId: b.chainId,
        nodeUrl: `${b.rpcEndpoints[0].protocol}://${b.rpcEndpoints[0].host}:${b.rpcEndpoints[0].port}`,
      })),
    });
    const session = await eLink.restoreSession("anchor-link-demo-multipass");
    const sessions = await eLink.listSessions("anchor-link-demo-multipass");

    setIdentitySession(session);
    setSessions(sessions);
    setLink(eLink);
  };

  const addAccount = async () => {
    try {
      // !Use the anchor-link login method with the chain id to establish a session
      const identity = await link.login("anchor-link-demo-multipass");

      //!Retrieve a list of all available sessions to update demo state
      const sessions = await link.listSessions("anchor-link-demo-multipass");

      setIdentitySession(identity.session);
      setSessions(sessions);

      console.log(identity);
    } catch (error) {
      toastError("", error.message);
      identitySession?.link?.transport?.closeModal?.();
    }
  };

  const removeSession = async () => {
    let ls = identitySession;
    await link.removeSession("anchor-link-demo-multipass", ls.auth, ls.chainId);

    if (
      identitySession &&
      identitySession.auth.actor.equals(ls.auth.actor) &&
      identitySession.auth.permission.equals(ls.auth.permission)
    ) {
      console.log(identitySession);
      setIdentitySession();
    }
    setSessions(
      sessions.filter(
        (s) =>
          !(
            s.auth.actor.equals(ls.auth.actor) &&
            s.auth.permission.equals(ls.auth.permission)
          ),
      ),
    );
  };

  useEffect(() => {
    establishLink();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={""}>
      {identitySession ? (
        <>
          <Alert variant="secondary">
            <Alert.Heading className="text-primary">{t("great")}</Alert.Heading>
            <p className="mb-0">
              {t("youAreCurrentlySignedInAs")}{" "}
              <Alert.Link
                className="text-primary"
                target="_blank"
                rel="noopener noreferrer"
                href={`https://bloks.io/account/${String(
                  identitySession.auth.actor,
                )}`}
              >
                {String(identitySession.auth.actor)}
              </Alert.Link>
              .
            </p>
            <Button variant="danger" onClick={removeSession}>{t("removeOrChangeAccount")}</Button>
          </Alert>
        </>
      ) : (
        <Button variant="outline-light" onClick={addAccount} className="mb-1">{t("connectAnchorWallet")}</Button>
      )}
    </div>
  );
};

export default TransferNftButton;
